<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
       @change_language="handleHeaderClick"
      ></HeaderComponent> 
    <div
      class="dz-bnr-inr dz-bnr-inr-sm"
      style="background-image: url(/assets/images/relocation/Header2.png)"
    >
      <div class="container">
        <div class="dz-bnr-inr-entry">
          <h1 style="color: #0c27bd" class="text-center">{{pageContent.header_title}}</h1>
          <!-- <nav aria-label="breadcrumb" class="breadcrumb-row m-t15">
             <ul class="breadcrumb">
               <li class="breadcrumb-item"><a href="index.html">Home</a></li>
               <li class="breadcrumb-item active" aria-current="page">
                 About Us
               </li>
             </ul>
           </nav> -->
        </div>
      </div>
    </div>
    <br />
    <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background-image: url(/assets/images/relocation/Body1.png);
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <h2
          class="text-center text-uppercase"
          style="font-weight: 600; color: #0c27bd"
        >
        {{pageContent.welcoming_title}}        </h2>
        <br />
        <div class="row d-flex align-items-stretch">
          <div class="col-md-12 d-flex">
            <div
              class="dz-bnr-inr-entry overlay-white h-100"
              style="text-align: left"
            >
              <p
                class="text-left mb-2 text-black"
                style="font-size: 16px; text-align: left"
              >
              {{pageContent.welcoming_text}} 
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background: #f0f1f5;
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2
              class="text-center text-uppercase"
              style="font-weight: 600; color: #0c27bd"
            >
            {{pageContent.comprehensive_guides_title}} 
          </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="dz-bnr-inr-entry overlay-white2">
              <p style="font-size: 20px">
                {{pageContent.comprehensive_guides_text}} 
              </p>
            </div>
          </div>
        </div>
        <br />
        <div class="row d-flex align-items-stretch mt-4">
          <div class="col-md-4 d-flex">
            <router-link to="/essentials">
              <div class="dz-bnr-inr-entry h-100" style="text-align: left">
                <img
                  src="/assets/images/relocation/r1.png"
                  class="img-fluid d-block mx-auto"
                  alt=""
                />
                <p
                  class="text-left mb-2 text-primary text-center"
                  style="font-size: 16px"
                >
                {{pageContent.essentials_text}} 
                </p>
              </div>
            </router-link>
          </div>
          <div class="col-md-4 d-flex">
            <router-link to="/transportation">
              <div class="dz-bnr-inr-entry h-100" style="text-align: left">
                <img
                  src="/assets/images/relocation/r2.png"
                  class="img-fluid d-block mx-auto"
                  alt=""
                />
                <p
                  class="text-left mb-2 text-primary text-center"
                  style="font-size: 16px"
                >
                {{pageContent.transportation_text}} 
                </p>
              </div>
            </router-link>
          </div>
          <div class="col-md-4 d-flex">
            <router-link to="/community">
              <div class="dz-bnr-inr-entry h-100" style="text-align: left">
                <img
                  src="/assets/images/relocation/volunteer.png"
                  class="img-fluid d-block mx-auto"
                  alt=""
                />
                <p
                  class="text-left mb-2 text-primary text-center"
                  style="font-size: 16px"
                >
                {{pageContent.community_text}} 
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background-image: url(/assets/images/relocation/Body2.png);
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="dz-bnr-inr-entry overlay-white2 d-block mx-auto">
              <h2 class="text-left text-primary" style="font-weight: 400">
                {{pageContent.quote}} <br>
                {{pageContent.quote2}} 
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="dz-bnr-inr dz-bnr-inr-sm text-center"
      style="
        background: #f0f1f5;
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      "
    >
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-center text-uppercase" style="color: #0c27bd">
              {{pageContent.personalized_support_title}} 
            </h2>
            <div
              class="dz-bnr-inr-entry"
              style="
                padding: 30px 50px 0px 50px;
                border-radius: 10px;
                color: black;
                height: auto;
              "
            >
              <h4 class="text-left text-black" style="font-weight: 400">
                {{pageContent.personalized_support_text}} 
              </h4>
            </div>
          </div>
        </div>
        <br />
        <router-link :to="'/contact-us'">
          <button
            class="btn btn-primary d-block mx-auto text-white"
            style="padding: 15px 60px; border-radius: 25px"
          >
          {{pageContent.contact_us_button}} 
        </button>
        </router-link>
      </div>
    </div>
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "Relocation",
  components: {
    HeaderComponent,
    FooterComponent,
  }, 
  data(){
    return {
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
    }
  }, mounted() {
    const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    this.language = storedLanguage;
  }
  this.convertLanguage();
  },
  methods: {
    goToRegister() {
      window.location = "/user/register";
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.relocation[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };
      
        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        }
        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        }
        
      }  
    },
  },
};
</script>

<style scoped>
.overlay-white {
  background-color: rgba(255, 255, 255, 0.95); /* White with 80% opacity */
  padding: 50px;
  border-radius: 10px;
  color: black;
}
.overlay-white2 {
  background-color: rgba(255, 255, 255, 0.95); /* White with 80% opacity */
  padding: 20px 50px;
  border-radius: 10px;
  height: auto;
  color: black;
}
ul li {
  list-style: inside;
  font-size: 16px;
}
</style>